module.exports = __webpack_public_path__ + "static/media/Adhamo-iphone12Max.9a6fd256.png";